/* 
	Sample Usage:
		jsonpRequest(apiUrl).then(data=>{
			console.log("Successs;",data);
		},
		error=>{
			console.error("Error:",error);
		});
*/
function removeScriptTag(scriptEl){
    if(scriptEl.remove!=null){
        scriptEl.remove();
    }
    else{
        // IE support
        scriptEl.parentNode.removeChild(scriptEl);
    }
}
function jsonpRequest(apiUrl) {
    return new Promise((resolve, reject) => {

        let script = document.createElement('script');
        const randomNumber = Math.floor((Math.random() * 10000) + 1);
        let functionName = `jsonpRequest_${randomNumber}`;
        script.onload = e => {
            delete(window[functionName]);
            removeScriptTag(script);

        }
        script.onerror = error => {
            reject(error);
            delete(window[functionName]);
            removeScriptTag(script);

        };
        document.head.appendChild(script);
        window[functionName] = data => {
            resolve(data);
        }
        script.src = `${apiUrl}?callback=${functionName}`;

    })
}

export { jsonpRequest }